import { FC } from 'react';

import ColumnarListSkeleton from '../ColumnarListSkeleton';

export const WORKSPACE_RESOURCE_LIST_ACTIONS_WIDTH_REM = 9;
export const WORKSPACE_RESOURCE_LIST_COLUMN_COUNT = 3;

interface WorkspaceResourceListSkeletonProps {
    rows?: number;
}

const WorkspaceResourceListSkeleton: FC<WorkspaceResourceListSkeletonProps> = ({ rows = 16 }) => (
    <ColumnarListSkeleton
        actionColumnWidthRem={WORKSPACE_RESOURCE_LIST_ACTIONS_WIDTH_REM}
        ariaLabel='Loading workspace resources'
        columnCount={WORKSPACE_RESOURCE_LIST_COLUMN_COUNT}
        includeHeader={false}
        rowDataAttribute='data-workspace-resource-list-skeleton-row'
        rows={rows}
        style={{ padding: '0 1rem' }}
    />
);

export default WorkspaceResourceListSkeleton;
